import type { Attempt, AttemptUpdate } from '../types'
import { questions } from '../data/questions'
const KEY = 'sangmath-dgnl-attempts-v1'
export const loadAttempts = (): Attempt[] => {
  try {
    const saved: unknown[] = JSON.parse(localStorage.getItem(KEY) || '[]')
    return saved.filter((item): item is Attempt => Boolean(item && typeof item === 'object')).map((item: any) => {
      const question = questions.find(candidate => candidate.id === item.questionId)
      return {
      id: item.id || `legacy-${item.questionId}-${item.at || Date.now()}`,
      questionId: item.questionId,
      answer: item.answer ?? '',
      correct: Boolean(item.correct),
      timeSeconds: Number(item.timeSeconds) || 0,
      competency: item.competency?.length ? item.competency : (question?.competency || ['problem-solving']),
      knowledge: item.knowledge?.length ? item.knowledge : (question?.knowledge || ['algebra']),
      topic: item.topic || question?.topic || 'Chưa phân loại',
      variantGroup: item.variantGroup || question?.variantGroup || item.questionId,
      prerequisites: item.prerequisites?.length ? item.prerequisites : (question?.prerequisites || item.knowledge || ['algebra']),
      confidence: item.confidence || 'medium',
      misconception: item.misconception,
      hintLevel: Number(item.hintLevel) || 0,
      session: item.session || 'practice',
      at: item.at || new Date().toISOString(),
      reviewDueAt: item.reviewDueAt,
      serverPersisted: Boolean(item.serverPersisted),
      }
    })
  } catch { return [] }
}
export const saveAttempts = (items: Attempt[]) => localStorage.setItem(KEY, JSON.stringify(items.slice(-1000)))
export const updateStoredAttempt = (items: Attempt[], id: string, update: AttemptUpdate) =>
  items.map(item => item.id === id ? { ...item, ...update } : item)
